import { Page } from 'componentregistry';

export default function getPageJson(ds: string) {
  return {
    '01hnd2xf84w7chadyty7d5jgkg': {
      children: ['01hp1szhspf29m3ts0ygdv5kfk'],
      itemId: '01hnd2xf84w7chadyty7d5jgkg',
      parent: 'root',
      props: {
        alias: 'ioCustomTemplatesAlias',
        dataSource: 'IoCustomTemplates',
      },
      type: 'DataStore',
    },
    '01hnd2y3adsrvbwd40vca39h5p': {
      children: ['01hndr27qsmxcnebzx4m8sjfc7'],
      itemId: '01hnd2y3adsrvbwd40vca39h5p',
      parent: 'root',
      props: {
        alias: 'ioCustomTemplatesAlias',
      },
      type: 'DataStoreReference',
    },
    '01hnd2zhrvt1v70jedxk8bvbgn': {
      children: [
        '01hnd3d438mx5sam5cjv9sz88q',
        '01hnd307pa4de2f2t2a9bradh7',
        '01hnd30a25cey50wnba8sz966w',
        '01hnd30mtq0bp1j2hqy5kq564k',
        '01hnd30ye07m3jxae1g7tbfs8r',
        '01hp1sxf1bdbhtgknb7g2ebaj4',
        '01hnd315v3vbyk45h38pmn7tgy',
      ],
      itemId: '01hnd2zhrvt1v70jedxk8bvbgn',
      parent: '01hndr27qtar3g6jw2xnets7bn',
      props: {
        expandLastColumn: false,
        insertable: {
          type: 'boolean',
          value: true,
        },
        updatable: {
          type: 'boolean',
          value: true,
        },
      },
      type: 'DataGrid',
    },
    '01hnd307pa4de2f2t2a9bradh7': {
      children: [],
      itemId: '01hnd307pa4de2f2t2a9bradh7',
      parent: '01hnd2zhrvt1v70jedxk8bvbgn',
      props: {
        insertable: {
          type: 'boolean',
          value: true,
        },
        label: {
          type: 'text',
          value: 'Code',
        },
        updatable: {
          type: 'boolean',
          value: false,
        },
        viewAttribute: 'code',
        width: 300,
      },
      type: 'StringColumn',
    },
    '01hnd30a25cey50wnba8sz966w': {
      children: [],
      itemId: '01hnd30a25cey50wnba8sz966w',
      parent: '01hnd2zhrvt1v70jedxk8bvbgn',
      props: {
        insertable: {
          type: 'boolean',
          value: true,
        },
        label: {
          type: 'text',
          value: 'Description',
        },
        updatable: {
          type: 'boolean',
          value: true,
        },
        viewAttribute: 'description',
        width: 400,
      },
      type: 'StringColumn',
    },
    '01hnd30mtq0bp1j2hqy5kq564k': {
      children: [],
      itemId: '01hnd30mtq0bp1j2hqy5kq564k',
      parent: '01hnd2zhrvt1v70jedxk8bvbgn',
      props: {
        label: {
          type: 'text',
          value: 'File Type',
        },
        optionValues: {
          type: 'text',
          value: 'D:Download Template',
        },
        viewAttribute: 'fileType',
        width: 300,
      },
      type: 'SelectColumn',
    },
    '01hnd30ye07m3jxae1g7tbfs8r': {
      children: [],
      itemId: '01hnd30ye07m3jxae1g7tbfs8r',
      parent: '01hnd2zhrvt1v70jedxk8bvbgn',
      props: {
        accept: '.xlsx',
        insertable: {
          type: 'boolean',
          value: true,
        },
        label: {
          type: 'text',
          value: 'File',
        },
        showRevisions: true,
        updatable: {
          type: 'boolean',
          value: true,
        },
        viewAttribute: 'fileUid',
        width: 400,
      },
      type: 'AttachmentColumn',
    },
    '01hnd315v3vbyk45h38pmn7tgy': {
      children: ['01hnd3caw7k1xmfh3vhrs0h0s6'],
      itemId: '01hnd315v3vbyk45h38pmn7tgy',
      parent: '01hnd2zhrvt1v70jedxk8bvbgn',
      props: {
        color: 'error',
        icon: {
          iconName: 'trash-alt',
          iconType: 'light',
        },
        label: {
          type: 'text',
          value: 'Delete',
        },
      },
      type: 'IconColumn',
    },
    '01hnd3caw7k1xmfh3vhrs0h0s6': {
      children: ['01hnd3cg331cz4xsk433atner4'],
      itemId: '01hnd3caw7k1xmfh3vhrs0h0s6',
      parent: '01hnd315v3vbyk45h38pmn7tgy',
      props: {},
      type: 'TriggerOnClick',
    },
    '01hnd3cg331cz4xsk433atner4': {
      children: [],
      itemId: '01hnd3cg331cz4xsk433atner4',
      parent: '01hnd3caw7k1xmfh3vhrs0h0s6',
      props: {
        alias: 'ioCustomTemplatesAlias',
      },
      type: 'ActionDeleteCurrentRecord',
    },
    '01hnd3d438mx5sam5cjv9sz88q': {
      children: [],
      itemId: '01hnd3d438mx5sam5cjv9sz88q',
      parent: '01hnd2zhrvt1v70jedxk8bvbgn',
      props: {
        label: {
          type: 'text',
          value: '#',
        },
      },
      type: 'RowNumberColumn',
    },
    '01hnd3g45s844xw1a8yf1xsamb': {
      children: ['01hnd3g45sxxfv8v2fhah5vx4x'],
      itemId: '01hnd3g45s844xw1a8yf1xsamb',
      parent: '01hndr37p4nx9hq7wm95faa2vw',
      props: {
        icon: {
          iconName: 'redo-alt',
          iconType: 'regular',
        },
        toolTip: {
          type: 'text',
          value: 'Refresh',
        },
      },
      type: 'IconButton',
    },
    '01hnd3g45sxxfv8v2fhah5vx4x': {
      children: ['01hnfjg01qy2dk7nwmbjmz280f'],
      itemId: '01hnd3g45sxxfv8v2fhah5vx4x',
      parent: '01hnd3g45s844xw1a8yf1xsamb',
      props: {},
      type: 'TriggerOnClick',
    },
    '01hnd3ha088283vxahd71jajjd': {
      children: ['01hnd3nfpjdzg23de8wp597tbk'],
      itemId: '01hnd3ha088283vxahd71jajjd',
      parent: '01hnd3ha088p9e1nqpp61dcpcs',
      props: {},
      type: 'TriggerOnClick',
    },
    '01hnd3ha088p9e1nqpp61dcpcs': {
      children: ['01hnd3ha088283vxahd71jajjd'],
      itemId: '01hnd3ha088p9e1nqpp61dcpcs',
      parent: '01hndr37p4nx9hq7wm95faa2vw',
      props: {
        startIcon: {
          iconName: 'circle-plus',
          iconType: 'light',
        },
        text: {
          type: 'text',
          value: 'Create',
        },
      },
      type: 'Button',
    },
    '01hnd3m4erb64fste5rknecjpn': {
      children: ['01hnd3n3npj292enyx99yp38fp'],
      itemId: '01hnd3m4erb64fste5rknecjpn',
      parent: '01hnd3m4erg1ebh5fyswhp2zab',
      props: {},
      type: 'TriggerOnClick',
    },
    '01hnd3m4erg1ebh5fyswhp2zab': {
      children: ['01hnd3m4erb64fste5rknecjpn'],
      itemId: '01hnd3m4erg1ebh5fyswhp2zab',
      parent: '01hndr37p4nx9hq7wm95faa2vw',
      props: {
        disableCondition: '!$.ioCustomTemplatesAlias.$dirty',
        startIcon: {
          iconName: 'save',
          iconType: 'light',
        },
        text: {
          type: 'text',
          value: 'Save',
        },
      },
      type: 'Button',
    },
    '01hnd3n3npj292enyx99yp38fp': {
      children: [],
      itemId: '01hnd3n3npj292enyx99yp38fp',
      parent: '01hnd3m4erb64fste5rknecjpn',
      props: {
        alias: 'ioCustomTemplatesAlias',
        silent: true,
      },
      type: 'ActionSave',
    },
    '01hnd3nfpjdzg23de8wp597tbk': {
      children: ['01hnf0sf6k1yfp3tq69psp1c9j', '01hp1jh2td7qyvmfpwq3rn4tmg'],
      itemId: '01hnd3nfpjdzg23de8wp597tbk',
      parent: '01hnd3ha088283vxahd71jajjd',
      props: {
        alias: 'ioCustomTemplatesAlias',
      },
      type: 'ActionCreate',
    },
    '01hndr27qsmxcnebzx4m8sjfc7': {
      children: ['01hndr2w9c0qx4xtsw08gne58x', '01hndr27qtar3g6jw2xnets7bn'],
      itemId: '01hndr27qsmxcnebzx4m8sjfc7',
      parent: '01hnd2y3adsrvbwd40vca39h5p',
      props: {},
      type: 'FlexPanel',
    },
    '01hndr27qtar3g6jw2xnets7bn': {
      children: ['01hnd2zhrvt1v70jedxk8bvbgn'],
      itemId: '01hndr27qtar3g6jw2xnets7bn',
      parent: '01hndr27qsmxcnebzx4m8sjfc7',
      props: {
        padding: {
          bottom: 0,
          left: 0,
          right: 0,
          top: 8,
        },
      },
      type: 'FlexItem',
    },
    '01hndr2w9c0qx4xtsw08gne58x': {
      children: ['01hndr37p4nx9hq7wm95faa2vw'],
      itemId: '01hndr2w9c0qx4xtsw08gne58x',
      parent: '01hndr27qsmxcnebzx4m8sjfc7',
      props: {
        sizeType: 'auto',
      },
      type: 'FlexItem',
    },
    '01hndr37p4nx9hq7wm95faa2vw': {
      children: [
        '01hnd3ha088p9e1nqpp61dcpcs',
        '01hnd3m4erg1ebh5fyswhp2zab',
        '01hnd3g45s844xw1a8yf1xsamb',
      ],
      itemId: '01hndr37p4nx9hq7wm95faa2vw',
      parent: '01hndr2w9c0qx4xtsw08gne58x',
      props: {
        gap: '8px',
        justifyContent: 'flex-end',
        padding: {
          bottom: 0,
          left: 0,
          right: 0,
          top: 4,
        },
      },
      type: 'Box',
    },
    '01hnf0sf6k1yfp3tq69psp1c9j': {
      children: [],
      itemId: '01hnf0sf6k1yfp3tq69psp1c9j',
      parent: '01hnd3nfpjdzg23de8wp597tbk',
      props: {
        attribute: 'datasourceUid',
        value: {
          type: 'text',
          value: ds,
        },
      },
      type: 'ActionSet',
    },
    '01hnfhxwt2h02yyzyw702t4axg': {
      children: [],
      itemId: '01hnfhxwt2h02yyzyw702t4axg',
      parent: '01hnfj4s33e989v5xf8srw8252',
      props: {
        attribute: 'datasourceUid',
        operator: 'is',
        value: [
          {
            type: 'text',
            value: ds,
          },
        ],
      },
      type: 'ActionSetQueryFilter',
    },
    '01hnfj4kd18d3nh4t1e087azs3': {
      children: ['01hnfj4s33e989v5xf8srw8252'],
      itemId: '01hnfj4kd18d3nh4t1e087azs3',
      parent: 'root',
      props: {},
      type: 'TriggerOnPageActive',
    },
    '01hnfj4s33e989v5xf8srw8252': {
      children: ['01hnfhxwt2h02yyzyw702t4axg'],
      itemId: '01hnfj4s33e989v5xf8srw8252',
      parent: '01hnfj4kd18d3nh4t1e087azs3',
      props: {
        alias: 'ioCustomTemplatesAlias',
      },
      type: 'ActionQuery',
    },
    '01hnfjg01qy2dk7nwmbjmz280f': {
      children: [],
      itemId: '01hnfjg01qy2dk7nwmbjmz280f',
      parent: '01hnd3g45sxxfv8v2fhah5vx4x',
      props: {
        alias: 'ioCustomTemplatesAlias',
      },
      type: 'ActionRefresh',
    },
    '01hp1jh2td7qyvmfpwq3rn4tmg': {
      children: [],
      itemId: '01hp1jh2td7qyvmfpwq3rn4tmg',
      parent: '01hnd3nfpjdzg23de8wp597tbk',
      props: {
        attribute: 'fileType',
        value: {
          type: 'text',
          value: 'D',
        },
      },
      type: 'ActionSet',
    },
    '01hp1sxf1bdbhtgknb7g2ebaj4': {
      children: [],
      itemId: '01hp1sxf1bdbhtgknb7g2ebaj4',
      parent: '01hnd2zhrvt1v70jedxk8bvbgn',
      props: {
        alignment: 'center',
        label: {
          type: 'text',
          value: 'Uploaded By',
        },
        size: 24,
        viewAttribute: 'lastUpdatedBy',
        hideOnlineStatus: true,
      },
      type: 'UserPicColumn',
    },
    '01hp1szhspf29m3ts0ygdv5kfk': {
      children: ['01hp1szqrh8zyfpw5wragabsc1'],
      itemId: '01hp1szhspf29m3ts0ygdv5kfk',
      parent: '01hnd2xf84w7chadyty7d5jgkg',
      props: {},
      type: 'TriggerBeforeQuery',
    },
    '01hp1szqrh8zyfpw5wragabsc1': {
      children: [],
      itemId: '01hp1szqrh8zyfpw5wragabsc1',
      parent: '01hp1szhspf29m3ts0ygdv5kfk',
      props: {
        attributeCode: 'lastUpdateDate',
        sortOrder: 'DESC',
      },
      type: 'ActionSetSort',
    },
    root: {
      children: [
        '01hnd2xf84w7chadyty7d5jgkg',
        '01hnfj4kd18d3nh4t1e087azs3',
        '01hnd2y3adsrvbwd40vca39h5p',
      ],
      itemId: 'root',
      parent: 'root',
      props: {
        windowTitle: {
          type: 'text',
          value: 'Blank Page',
        },
      },
      type: 'Page',
    },
  } as Page;
}
